import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

const KEY = "faq_items";
const DEFAULT_FRAGEN = [
  { frage: "Wie kann ich Produkte bestellen?", antwort: "Registrieren Sie sich kostenlos auf unserer Website. Nach der Freischaltung durch uns können Sie Produkte als Abo oder Einzelbestellung aufgeben." },
  { frage: "Wie läuft die Lieferung ab?", antwort: "Wir liefern direkt vom Hof zu Ihnen nach Hause. Die genauen Liefertage für Ihre Region erfahren Sie nach der Registrierung." },
  { frage: "Kann ich mein Abo pausieren oder kündigen?", antwort: "Ja – über Ihr Profil können Sie Ihr Abo jederzeit anpassen, pausieren oder kündigen." },
  { frage: "Was passiert, wenn ich eine Bestellung nicht erhalten habe?", antwort: "Bitte melden Sie sich telefonisch oder per E-Mail bei uns. Wir klären das schnellstmöglich für Sie." },
  { frage: "Wie bezahle ich meine Bestellungen?", antwort: "Die Abrechnung erfolgt monatlich. Zahlungsdetails erhalten Sie nach Ihrer Registrierung." },
  { frage: "Werden die Produkte frisch geliefert?", antwort: "Ja, alle unsere Milchprodukte stammen direkt vom Hof und werden frisch geliefert – ohne lange Transportwege." },
  { frage: "Gibt es ein Schulmilchprogramm?", antwort: "Ja! Wir bieten frische Milch für Schulen und Kindergärten an – gefördert durch die Europäische Union. Mehr Infos unter 'Schule & Kindergarten'." },
  { frage: "Wie erreiche ich euch am besten?", antwort: "Telefonisch Mo – Fr von 07:30 – 11:30 Uhr oder per E-Mail. Die Kontaktdaten finden Sie auf der Kontaktseite." },
];

function FAQItem({ frage, antwort }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border: "1.5px solid #e0e0e0", borderRadius: "10px", marginBottom: "0.75rem", overflow: "hidden" }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", padding: "1rem 1.25rem",
        background: open ? "#f1f8e9" : "white", border: "none", cursor: "pointer",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        fontWeight: 600, fontSize: "1rem", color: "#1b5e20", fontFamily: "inherit",
      }}>
        {frage}
        <span style={{ fontSize: "1.1rem", transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "none" }}>▾</span>
      </button>
      {open && (
        <div style={{ padding: "0.85rem 1.25rem 1rem", color: "#555", fontSize: "0.95rem", borderTop: "1px solid #e8f5e9", lineHeight: 1.6 }}>
          {antwort}
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;
  const [fragen, setFragen] = useState(DEFAULT_FRAGEN);
  const [editIdx, setEditIdx] = useState(null); // index being edited, or -1 for new
  const [editForm, setEditForm] = useState({ frage: "", antwort: "" });
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setFragen(typeof r === "string" ? JSON.parse(r) : r); }).catch(() => {});
  }, []);

  async function persist(newFragen) {
    await api.einstellungen.update(KEY, JSON.stringify(newFragen));
    setFragen(newFragen);
    setMsg("✓ Gespeichert!");
    setTimeout(() => setMsg(null), 3000);
  }

  async function saveEdit() {
    try {
      const updated = editIdx === -1
        ? [...fragen, editForm]
        : fragen.map((f, i) => i === editIdx ? editForm : f);
      await persist(updated);
      setEditIdx(null);
    } catch { setMsg("Fehler beim Speichern."); }
  }

  async function deleteItem(idx) {
    if (!window.confirm("Frage löschen?")) return;
    try {
      await persist(fragen.filter((_, i) => i !== idx));
    } catch { setMsg("Fehler beim Löschen."); }
  }

  function startEdit(idx) {
    setEditIdx(idx);
    setEditForm(idx === -1 ? { frage: "", antwort: "" } : { ...fragen[idx] });
    setMsg(null);
  }

  return (
    <div className="container">
      <h2 className="section-title">❓ Häufig gestellte Fragen</h2>
      <p style={{ color: "#555", marginBottom: "2rem", fontSize: "1.05rem" }}>
        Hier finden Sie Antworten auf die häufigsten Fragen rund um unsere Produkte und Lieferungen.
      </p>
      {msg && <p style={{ color: msg.startsWith("✓") ? "green" : "red", marginBottom: "1rem" }}>{msg}</p>}

      <div style={{ maxWidth: 700 }}>
        {fragen.map((item, i) => (
          <div key={i}>
            {editIdx === i ? (
              <div style={{ border: "1.5px solid #66bb6a", borderRadius: 10, padding: "1rem", marginBottom: "0.75rem" }}>
                <input value={editForm.frage} onChange={e => setEditForm(f => ({ ...f, frage: e.target.value }))}
                  placeholder="Frage" style={IN} />
                <textarea rows={3} value={editForm.antwort} onChange={e => setEditForm(f => ({ ...f, antwort: e.target.value }))}
                  placeholder="Antwort" style={TA} />
                <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
                  <button className="btn btn-primary" onClick={saveEdit}>Speichern</button>
                  <button className="btn btn-secondary" onClick={() => setEditIdx(null)}>Abbrechen</button>
                </div>
              </div>
            ) : (
              <div style={{ position: "relative" }}>
                <FAQItem frage={item.frage} antwort={item.antwort} />
                {isAdmin && (
                  <div style={{ position: "absolute", top: "0.6rem", right: "2.5rem", display: "flex", gap: "0.3rem" }}>
                    <button onClick={() => startEdit(i)} style={ICON_BTN} title="Bearbeiten">✏️</button>
                    <button onClick={() => deleteItem(i)} style={ICON_BTN} title="Löschen">🗑️</button>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        {isAdmin && editIdx !== -1 && (
          <button className="btn btn-secondary" style={{ marginTop: "0.5rem" }} onClick={() => startEdit(-1)}>
            ➕ Neue Frage hinzufügen
          </button>
        )}
        {editIdx === -1 && (
          <div style={{ border: "1.5px solid #66bb6a", borderRadius: 10, padding: "1rem", marginTop: "0.5rem" }}>
            <input value={editForm.frage} onChange={e => setEditForm(f => ({ ...f, frage: e.target.value }))}
              placeholder="Neue Frage" style={IN} />
            <textarea rows={3} value={editForm.antwort} onChange={e => setEditForm(f => ({ ...f, antwort: e.target.value }))}
              placeholder="Antwort" style={TA} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
              <button className="btn btn-primary" onClick={saveEdit}>Hinzufügen</button>
              <button className="btn btn-secondary" onClick={() => setEditIdx(null)}>Abbrechen</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const TA = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "0.95rem", marginBottom: "0.25rem", resize: "vertical", fontFamily: "inherit" };
const IN = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "1rem", marginBottom: "0.5rem", fontFamily: "inherit", fontWeight: 600 };
const ICON_BTN = { background: "none", border: "none", cursor: "pointer", fontSize: "0.85rem", padding: "2px 4px", borderRadius: 4 };
